import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { jwCrownIcon } from '@/plugins/global-fontawesome';


export default /*#__PURE__*/_defineComponent({
  __name: 'FreemiumFilterBadge',
  props: {
    size: { default: 'sm' }
  },
  setup(__props: any) {

const props = __props as { size: 'sm' | 'md' | 'lg' };



const classNames = computed(() => {
	return {
		'freemium-filter__badge': true,
		[`freemium-filter__badge--${props.size}`]: props.size,
	};
});

return { __sfc: true,props, classNames, jwCrownIcon }
}

})